import { useEffect, useState, createContext, useContext } from 'react';
import { Session, User } from '@supabase/supabase-js';
import { SubscriptionType, supabase } from '@upcaret/supabase-types';
import { QueryClient } from '@tanstack/react-query';

export interface AuthSession {
  queryClient: QueryClient | null;
  user: User | null;
  session: Session | null;
  subscription: SubscriptionType | null;
  pageTitle: string | null;
}

export const UserContext = createContext<AuthSession>({
  queryClient: null,
  user: null,
  session: null,
  subscription: null,
  pageTitle: null,
});

export interface Props {
  queryClient: QueryClient;
  [propName: string]: any;
}

export const UserContextProvider = (props: Props) => {
  const { queryClient } = props;
  // const [session, setSession] = useState<Session | null>(null);
  // const [user, setUser] = useState<User | null>(session?.user ?? null);
  // const [subscription, setSubscription] = useState<SubscriptionType | null>(
  //   null
  // );
  const [pageTitle, setPageTitle] = useState<string | null>(null);
  // const [sessionQueryIsEnabled, setSessionQueryIsEnabled] =
  //   useState<boolean>(false);
  // const [userQueryIsEnabled, setUserQueryIsEnabled] = useState<boolean>(false);
  // const [subscriptionQueryIsEnabled, setSubscriptionQueryIsEnabled] =
  //   useState<boolean>(false);

  // const fetchSession = async () => {
  //   const { data } = await supabase.auth.getSession();
  //   return data.session;
  // };

  // const fetchUser = async () => {
  //   const { data } = await supabase.auth.getSession();
  //   const user = data.session?.user ?? null;
  //   return user;
  // };

  // const fetchSubscription = async () => {
  //   const { data: subscriptionData } = await supabase
  //     .schema('api')
  //     .from('subscription')
  //     .select()
  //     .maybeSingle();
  //   return subscriptionData;
  // };

  // const sessionQuery = useQuery({
  //   queryKey: ['session'],
  //   queryFn: fetchSession,
  //   // enabled: sessionQueryIsEnabled,
  // });

  // const userQuery = useQuery({
  //   queryKey: ['user'],
  //   queryFn: fetchUser,
  //   // enabled: userQueryIsEnabled && !!sessionQuery.data,
  // });

  // const subscriptionQuery = useQuery({
  //   queryKey: ['subscription'],
  //   queryFn: fetchSubscription,
  //   // enabled: subscriptionQueryIsEnabled && !!session,
  // });

  useEffect(() => {
    const { data: authListener } = supabase.auth.onAuthStateChange(
      async (event, session) => {
        if (event === 'SIGNED_IN') {
          // setSessionQueryIsEnabled(true);
          // setUserQueryIsEnabled(true);
          // setSubscriptionQueryIsEnabled(true);
          // queryClient.setQueryData(['session'], session);
          // queryClient.setQueryData(['user'], session?.user ?? null);
          // queryClient.setQueryData(['subscription'], await fetchSubscription());
        } else if (event === 'SIGNED_OUT') {
          // setSessionQueryIsEnabled(false);
          // setUserQueryIsEnabled(false);
          // setSubscriptionQueryIsEnabled(false);
          // queryClient.invalidateQueries();
        } else if (event === 'USER_UPDATED') {
          // TODO: this is a hack so the user doesn't have to log out
          // window.location.reload();
          // console.log('userupdatesd');
          // await queryClient.invalidateQueries();
          // await sessionQuery.refetch();
          // await userQuery.refetch();
          // await subscriptionQuery.refetch();
        }
      }
    );

    return () => {
      authListener?.subscription.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const value = {
    queryClient: queryClient,
    session: null,
    user: null,
    subscription: null,
    pageTitle,
  };
  return <UserContext.Provider value={value} {...props} />;
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error(`useUser must be used within a UserContextProvider.`);
  }
  return context;
};
